export const pickProductImage = (product) => {
  if (!product || typeof product !== 'object') return null;
  return (
    product.image_url ||
    product.front_image_url ||
    product.image_front_url ||
    product.image_front_small_url ||
    null
  );
};

export const resolveNutritionImageUrl = (imageUrl) => {
  if (!imageUrl) return null;

  const raw = String(imageUrl).trim();
  if (!raw) return null;
  if (raw.startsWith('http') || raw.startsWith('data:')) return raw;

  const backendBase = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  if (!backendBase) return raw;

  if (raw.startsWith('/api/')) return `${backendBase}${raw}`;

  if (raw.startsWith('/uploads/')) {
    const normalized = raw.replace(/^\/uploads\//, '');
    return `${backendBase}/api/portal/nutrition/uploads/${normalized}`;
  }

  if (raw.startsWith('uploads/')) {
    const normalized = raw.replace(/^uploads\//, '');
    return `${backendBase}/api/portal/nutrition/uploads/${normalized}`;
  }

  if (raw.includes('/uploads/')) {
    const normalized = raw.split('/uploads/')[1]?.replace(/^\/+/, '');
    if (normalized) {
      return `${backendBase}/api/portal/nutrition/uploads/${normalized}`;
    }
  }

  return `${backendBase}${raw.startsWith('/') ? '' : '/'}${raw}`;
};